// extracted by mini-css-extract-plugin
export default {"root":"TaskList_root__WMW5i","operation":"TaskList_operation__qdEg5"};